const getters = {
  instrument_in_updates: state => instrument_id => {
    return state.updates.filter(
      update => update.instruments.includes(instrument_id)
    )
  }
}

export default getters
